import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(): boolean {
    if ( this.auth.isLoggedIn() ) {
      console.log('CanActivate true');
      return true;
    } else {
      console.log('CanActivate false');
      this.router.navigate(['/']);
      return false;
    }
  }

}
